import React from "react";
import moment from "moment";
import { inject, observer } from "mobx-react";

import { Spin, Alert, message, Button } from "antd";

import Language from "../language/language";
import AdaptiveTooltip from "../AdaptiveTooltip";
import { $util } from "../../helper";
import agent from "../../agent";

import "./stylesheets/confirmPersonalInfo.scss";

const personal_info_keys_map = [
	{
		key: "nickname",
		LanguageKey: "CHINESE_NAME",
	},
	{
		key: "nickname_en",
		LanguageKey: "ENGLISH_NAME",
	},
	{
		key: "phone_number",
		LanguageKey: "PHONE_NUMBER",
	},
	{
		key: "contact_email",
		LanguageKey: "EMAIL",
	},
	{
		key: "degree",
		LanguageKey: "H_EDUCATION",
	},
	{
		key: "college_name",
		LanguageKey: "H_SCHOOL",
	},
	{
		key: "institute_name",
		LanguageKey: "H_COLLEGE",
	},
	{
		key: "major",
		LanguageKey: "H_MAJOR",
	},
	{
		key: "begin_at",
		LanguageKey: "H_START_TIME",
	},
	{
		key: "end_at",
		LanguageKey: "H_END_TIME",
	},
];

@inject("languageStore")
@observer
class ConfirmPersonalInfo extends React.Component {
	state = {
		isLoading: true,
		info: null,
		errorTips: "",
	};

	componentDidMount() {
		// 获取当前用户的个人信息
		Promise.all([
			agent.Auth.current(),
			agent.Auth.getEducations(),
		])
			.then((res) => {
				const userInfo = res[0].member;
				const educationsInfo = res[1].educations;
				const user = this.getUserInfo(userInfo),
					education = this.getHEducationInfo(
						educationsInfo
					);
				this.judgeEducation(education);
				this.setState({
					info: {
						...user,
						...education,
					},
					isLoading: false,
				});
			})
			.catch((err) => {
				console.log(err);
				message.error("出错了，请刷新页面重试。");
			});
	}

	judgeEducation = (education) => {
		const { degree, end_at, begin_at } = education;
		const startYear = moment(begin_at).year();
		const endYear = moment(end_at).year();
		let errorTips = "";
		if (degree.includes("本科")) {
			/**
       * 【本科】
          看结束时间的年份 - 开始时间的年份 ≠ 4 就提示：
          本科经历时间小于4年，请确认学历时间是否正确
       */
			if (endYear - startYear < 4) {
				errorTips = "H_EDUCATION_ERROR_TIPS_0";
			} else if (endYear - startYear > 4) {
				errorTips = "H_EDUCATION_ERROR_TIPS_1";
			}
		} else if (degree.includes("硕士")) {
			/**
       * 【硕士】结束时间的年份 - 开始时间的年份
          >3 提示：硕士经历持续时间大于3年，请确认学历时间是否正确
          =0 提示：硕士经历持续时间为0年，请确认学历时间是否正确
       */
			if (endYear - startYear > 3) {
				errorTips = "H_EDUCATION_ERROR_TIPS_2";
			} else if (endYear - startYear === 0) {
				errorTips = "H_EDUCATION_ERROR_TIPS_3";
			}
		} else if (degree.includes("博士")) {
			/**
       * 【博士】结束时间的年份 - 开始时间的年份
          >6 提示：博士经历持续时间大于6年，请确认学历时间是否正
          <3 提示：博士经历持续时间小于3年，请确认学历时间是否正确
       */
			if (endYear - startYear > 6) {
				errorTips = "H_EDUCATION_ERROR_TIPS_4";
			} else if (endYear - startYear < 3) {
				errorTips = "H_EDUCATION_ERROR_TIPS_5";
			}
		}
		this.setState({
			errorTips,
		});
	};

	getUserInfo = (user) => {
		const {
			nickname,
			nickname_en,
			phone_number,
			contact_email,
		} = user;
		return {
			nickname,
			nickname_en,
			phone_number,
			contact_email,
		};
	};

	/**
	 * 获取当前用户的最高学历
	 * 判断条件：所有学历记录中，结束时间最晚的，若有两条一致，则为开始时间最晚的，仍有一致，则取第一条
	 */
	getHEducationInfo = (educations) => {
		if (
			!(Array.isArray(educations) && educations.length > 0)
		) {
			return [];
		}
		if (educations.length === 1) {
			// 只有一段教育经历，则当前经历就为最高学历
			return educations[0];
		}
		// 将学历按结束时间倒序排序
		const sortedEducations = educations.sort(
			(itemA, itemB) => {
				const endTimeA = moment(itemA.end_at).valueOf();
				const endTimeB = moment(itemB.end_at).valueOf();
				return endTimeB - endTimeA;
			}
		);
		// 获取最近的学历的结束时间
		const hEducationEndTime = sortedEducations[0].end_at;
		// 相同结束时间的所有经历
		const sameEndTimeEducations = sortedEducations.filter(
			(item) => item.end_at === hEducationEndTime
		);
		if (
			sameEndTimeEducations &&
			sameEndTimeEducations.length === 1
		) {
			return sameEndTimeEducations[0];
		}
		// 按照开始时间顺序排序
		const sortedSameEndTimeEducations = sameEndTimeEducations.sort(
			(itemA, itemB) => {
				const startTimeA = moment(itemA.begin_at).valueOf();
				const startTimeB = moment(itemB.begin_at).valueOf();
				return startTimeA - startTimeB;
			}
		);
		return sortedSameEndTimeEducations[1];
	};

	openUserCenter = () => {
		this.props.onClose && this.props.onClose();
		$util.openPersonalCenter(this.props.languageStore.lang);
	};

	back = () => {
		this.props.onClose && this.props.onClose();
	};

	confirm = () => {
		this.props.onConfirm && this.props.onConfirm();
	};

	render() {
		const { isLoading, info, errorTips } = this.state;

		if (isLoading) {
			return (
				<div className="confirmPersonalInfo--spin">
					<Spin />
				</div>
			);
		}

		if (!info) {
			return <div>{"暂无个人信息"}</div>;
		}

		return (
			<div className="confirmPersonalInfo">
				{errorTips ? (
					<Alert
						className="confirmPersonalInfo__alert"
						message={<Language resource={errorTips} />}
						type="warning"
						showIcon
					/>
				) : null}
				<Alert
					className="confirmPersonalInfo__alert"
					message={
						<Language resource="CONFIRM_THE_ENTRY_INFO_TIPS" />
					}
					type="info"
					showIcon
				/>
				{personal_info_keys_map.map((item, index) => {
					const { LanguageKey, key } = item;
					const value = info[key];
					if (!value) return null;
					return (
						<AdaptiveTooltip
							key={`${info.id}-${index + 1}`}
							className="confirmPersonalInfo__contentItem"
							title={value}
						>
							<Language resource={LanguageKey} />
							{`: ${value}`}
						</AdaptiveTooltip>
					);
				})}
				<div
					className="confirmPersonalInfo__openUserCenter"
					onClick={this.openUserCenter}
				>
					<Language resource="CLICK_TO_UPDATE_PERSONAL_INFO" />
				</div>
				<div className="confirmPersonalInfo__btns">
					<Button
						className="confirmPersonalInfo__btns--back"
						onClick={this.back}
					>
						<Language resource="BACK" />
					</Button>
					<Button type="primary" onClick={this.confirm}>
						<Language resource="CONFIRM_INFO_IS_OK" />
					</Button>
				</div>
			</div>
		);
	}
}

export default ConfirmPersonalInfo;



// WEBPACK FOOTER //
// ./src/components/registrationCenter/confirmPersonalInfo.js